var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: "Tạo ghi chú hàng loạt",
        size: "sm",
        "use-panel": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.handleClose,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "sk-dialog__footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { plain: "" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("Hủy")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-save",
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v("Lưu")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticClass: "sk-dialog-content",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.formRules,
            "label-position": "top",
          },
        },
        [
          _c(
            "div",
            { staticClass: "sk-panel" },
            [
              _c("div", { staticClass: "sk-panel-head" }, [
                _c("div", { staticClass: "sk-panel-icon" }, [
                  _c("i", { staticClass: "el-icon-edit-outline" }),
                ]),
                _c("div", [
                  _c("p", { staticClass: "sk-panel-title" }, [
                    _vm._v("Tạo ghi chú hàng loạt"),
                  ]),
                  _c("p", { staticClass: "sk-panel-subtitle" }, [
                    _vm._v(
                      "Áp dụng cho " +
                        _vm._s(_vm.selectedCount) +
                        " phiếu thu đã chọn"
                    ),
                  ]),
                ]),
              ]),
              _c(
                "el-form-item",
                {
                  staticClass: "sk-u-mt-12",
                  attrs: { label: "Nội dung ghi chú", prop: "note" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder: "Nhập nội dung ghi chú...",
                      maxlength: "500",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.dataForm.note,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "note", $$v)
                      },
                      expression: "dataForm.note",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }